import React, { useState } from 'react'

import Form from 'components/form/form'
import copy from 'fast-copy'

import {
    postInvites,
    updateUserSubscriber
} from 'state/actions'
import { connect } from 'react-redux'

import {
    getAccountUsers,
    getCurrentUser
} from 'state/selectors'

import { parsedEmailAddresses } from 'utils/utils'

const Invite = ({
    refreshSlider,
    accountUsers,
    userData,
    closeCallback,
    postInvites,
    isActiveStep,
    updateUserSubscriber,
    appSumoUsers
}) => {
    const formRows = [
        [
            {
                key: 'invitations',
                type: 'inviteList',
                props: {
                    refreshSlider,
                    defaultItem: userData ? userData.email : ''
                }
            }
        ]
    ]

    const [formValues, setFormValues] = useState({})
    const [formError, setFormError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const handleError = message => {
        setFormError(message)

        setTimeout(() => {
            refreshSlider()
        }, 350)

        setTimeout(() => {
            setFormError(null)

            setTimeout(() => {
                refreshSlider()
            }, 350)
        }, 3200)
    }

    const handleSubmit = e => {
        e.preventDefault()

        if (isLoading) {
            return
        }

        const emails = formValues.invitations || []

        const parseResponse = parsedEmailAddresses(emails)

        const isInvitingGuests = false

        if (parseResponse.allValid) {
            if(appSumoUsers && !isNaN(parseInt(appSumoUsers))){
                if(parseResponse.validAddresses.length > (parseInt(appSumoUsers) - 1)){
                    return handleError(`Your lifetime deal only includes ${ appSumoUsers } users.`)
                }
            }

            let uniqueEmails = []

            parseResponse.validAddresses.forEach(email => {
                if (uniqueEmails.indexOf(email) == -1) {
                    uniqueEmails.push(email)
                }
            })

            let firstExistingEmail = null

            accountUsers.forEach(user => {
                if (!firstExistingEmail) {
                    firstExistingEmail = parseResponse.validAddresses.find(address => {
                        return address == user.email
                    })
                }
            })

            if (firstExistingEmail) {
                handleError("'" + firstExistingEmail + "' is already part of your team.")
                return
            }

            setIsLoading(true)

            postInvites(uniqueEmails, isInvitingGuests, _ => {
                setIsLoading(false)

                updateUserSubscriber({
                    AddedTeamMembers: 'Yes'
                })

                closeCallback()
            })
        } else {
            if (parseResponse.invalidAddresses.length) {
                handleError("'" + parseResponse.invalidAddresses[0] + "' isn't a valid email address.")
            } else {
                handleError("You'll need to enter some addresses first!")
            }
        }
    }

    const handleChange = (key, value) => {
        const _formValues = copy(formValues)

        _formValues[key] = value

        setFormValues(_formValues)
    }

    const handleClose = e => {
        if(e){
            e.preventDefault()
            e.stopPropagation()
        }

        closeCallback()
    }

    return (
        <React.Fragment>
            <Form
                rows={formRows}
                values={formValues}
                handleSubmit={handleSubmit}
                handleChange={handleChange}
                error={formError}
                isLoading={isLoading}
                isFocused={isActiveStep}
                buttonPrimary={{
                    label: 'Save details',
                    icon: 'tick'
                }}
                buttonLow={{
                    label: `Skip for now`,
                    callback: handleClose
                }}
            />
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        userData: getCurrentUser(state, true),
        accountUsers: getAccountUsers(state),
    }
}

export default connect(mapStateToProps, {
    postInvites,
    updateUserSubscriber
})(Invite)



// WEBPACK FOOTER //
// ./src/components/auth/register-modal/invite.jsx